module.exports = __webpack_public_path__ + "static/media/maestro.6a132883.svg";